import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtMoney } from "@/lib/api";
import { PageHeader, Loader, StatCard } from "@/components/ui-kit";
import { ValStatus, fmtDelay } from "@/lib/validation";
import { ClipboardCheck, Hourglass, CheckCircle2, XCircle, AlarmClock, Timer } from "lucide-react";

export default function ValidationDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/validations/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <Loader />;
  const s = d.by_statut;
  return (
    <div data-testid="validation-dashboard">
      <PageHeader title="Validations" subtitle={d.scope === "all" ? "Vue d'ensemble de toutes les demandes" : "Demandes qui vous concernent"} />
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3 mb-6">
        <Link to="/validations/en-attente"><StatCard label="À valider par moi" value={d.my_pending} icon={ClipboardCheck} accent="blue" /></Link>
        <StatCard label="En attente" value={(s["En attente de validation"] || 0) + (s["En cours de validation"] || 0)} icon={Hourglass} />
        <StatCard label="Approuvées" value={s["Approuvée"] || 0} icon={CheckCircle2} accent="green" />
        <StatCard label="Rejetées" value={s["Rejetée"] || 0} icon={XCircle} accent="red" />
        <StatCard label="En retard (> 48 h)" value={d.late} icon={AlarmClock} accent="orange" />
        <StatCard label="Délai moyen" value={fmtDelay(d.avg_delay_h)} icon={Timer} />
      </div>
      <div className="grid lg:grid-cols-3 gap-4">
        <div className="rounded-xl border bg-white p-4">
          <h3 className="font-head font-semibold mb-3">Par module</h3>
          {Object.keys(d.by_module).length === 0 ? <p className="text-sm text-slate-400">Aucune demande pour l'instant.</p> :
            Object.entries(d.by_module).map(([m, n]) => <div key={m} className="flex justify-between text-sm py-1 border-b last:border-0"><span>{m}</span><b>{n}</b></div>)}
        </div>
        <div className="rounded-xl border bg-white p-4 lg:col-span-2">
          <h3 className="font-head font-semibold mb-3">Activité récente</h3>
          {d.recent.length === 0 ? <p className="text-sm text-slate-400">Aucune demande pour l'instant.</p> : d.recent.map((r) => (
            <Link key={r.id} to={`/validations/demande/${r.id}`} className="flex flex-wrap items-center gap-2 py-2 border-b last:border-0 hover:bg-slate-50 text-sm" data-testid={`val-recent-${r.id}`}>
              <span className="font-mono text-xs text-brand-700">{r.numero}</span><span className="font-medium">{r.op_label} {r.source_ref}</span>
              <span className="text-slate-500 truncate max-w-[16rem]">{r.objet}</span>{r.montant != null && <span className="font-mono text-xs">{fmtMoney(r.montant)}</span>}
              <span className="ml-auto"><ValStatus s={r.statut} /></span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
